import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { useDropzone } from "react-dropzone";
import "./FullScreenDropzone.css";

const FullScreenDropzone = forwardRef(
  ({ onDrop, onDropReject, isUploadPage, children }, ref) => {
    const [showOverlay, setShowOverlay] = useState(false);

    const { getInputProps, getRootProps, open, isDragActive } = useDropzone({
      onDrop,
      onDropReject,
      accept: {
        "image/jpeg": [".jpeg", ".jpg"],
        "image/tiff": [".tiff", ".tif"],
        "image/png": [".png"],
        "application/pdf": [".pdf"],
      },
      maxFiles: 500,
      multiple: true,
      noClick: true,
      noKeyboard: true,
    });

    // 🔑 expose open() to parent
    useImperativeHandle(ref, () => ({
      openFileDialog: open,
    }));

    useEffect(() => {
      setShowOverlay(isDragActive);
      console.log("🎯 Drag state changed - isDragActive:", isDragActive);
    }, [isDragActive]);

    if (!isUploadPage) return <>{children}</>;

    return (
      <div className="full-screen-dropzone-wrapper" {...getRootProps()}>
        <input {...getInputProps()} />

        <div className={`full-screen-dropzone ${showOverlay ? "active" : ""}`}>
          <div className="base-inner">
            <span>Drop files here to upload</span>
          </div>
        </div>

        <div className="overlay-content">{children}</div>
      </div>
    );
  }
);

export default FullScreenDropzone;
